import api from "./api";

function basePath(type) {
  return `/recovery-directories/${type}`;
}

const recoveryDirectoryService = {
  upload: (type, file, { bankName, branchName } = {}) => {
    const formData = new FormData();
    formData.append("file", file);
    if (bankName) formData.append("bankName", bankName);
    if (branchName) formData.append("branchName", branchName);
    return api.post(`${basePath(type)}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 300000,
    });
  },

  removeBySource: (type, { bankName, branchName } = {}) =>
    api.delete(`${basePath(type)}/by-source`, {
      params: { bankName, branchName },
    }),

  listUploadSources: (type) => api.get(`${basePath(type)}/upload-sources`),

  list: (type, params = {}) => api.get(`${basePath(type)}`, { params }),

  downloadSample: (type) =>
    api.get(`${basePath(type)}/sample`, { responseType: "blob" }),

  downloadPublic: (kind, token) =>
    api.get(`/public/recovery-data/${kind}/download`, {
      params: token ? { token } : undefined,
      responseType: "blob",
      headers: token ? { "X-Download-Token": token } : undefined,
    }),

  publicSummary: () => api.get("/public/recovery-data/summary"),

  createPublicDownloadOrder: (kind) =>
    api.post(`/public/recovery-data/${kind}/create-order`),

  verifyPublicDownloadPayment: (kind, payload) =>
    api.post(`/public/recovery-data/${kind}/verify`, payload),
};

export default recoveryDirectoryService;
